import * as React from 'react';
import { withTheme } from 'emotion-theming';
import { PseudoBox, BoxProps } from '.';

export interface SurfaceProps extends BoxProps {
    elevation?: number;
    total?: number;
    theme?: any;
}

const Surface: React.FC<SurfaceProps> = ({
    elevation = 0,
    total = 1,
    theme = {},
    ...rest
}: SurfaceProps): React.ReactElement => {
    const isLight = theme.name === 'light';
    const colors = theme.colors.bg.surface;
    const shift = total - 1;
    let index = elevation;

    // light range gets reversed since 0 is white which should always be the top-most surface
    if (isLight) {
        index = Math.abs(elevation - shift);
    }

    return <PseudoBox bg={colors[index]} {...rest} />;
};

const ThemeWrapper = withTheme(Surface);

export default ThemeWrapper;
